import React, { forwardRef, useImperativeHandle, useState } from 'react';

import { ICellEditorParams } from '@lib/components/ui/ag-grid';
import { TimestampTimePicker } from '@lib/components/ui/date-picker';

const TimeCellEditor = forwardRef<any, ICellEditorParams>((props, ref) => {
  const [value, setValue] = useState(props.value);

  /* Component Editor Lifecycle methods */
  useImperativeHandle(ref, () => {
    return {
      getValue() {
        return value;
      },
    };
  });

  return (
    <TimestampTimePicker
      bordered={false}
      style={{ width: '100%' }}
      useSeconds
      utcTime
      value={value}
      onChange={setValue}
    />
  );
});

export default TimeCellEditor;
